
<template>
  <div class="privacy">
    <!-- Header -->
    <header class="header">
      <div class="logo-container">
        <img src="@/assets/logo_ziel.png" alt="Ziel Logo" class="logo" />
        <h1 class="title">Ziel</h1>
      </div>
      <h2 class="subtitle">Privacy Policy</h2>
    </header>

    <!-- Content -->
<section class="content">
  <h3>Privacy Policy</h3>
  <p>
    Your privacy is important to us. This Privacy Policy explains how we collect, use, and protect user information in the Ziel app.
  </p>

  <h3>Information We Collect</h3>
  <ul>
    <li><strong>Account Information:</strong> first and last name, email, date of birth, country, club and other profile data (profile picture optional).</li>
    <li><strong>Authentication:</strong> credentials used for authentication (passwords are protected and never visible to us).</li>
    <li><strong>Game Data:</strong> match details such as scores, dates, locations and related statistics.</li>
    <li><strong>Photos:</strong> profile picture and any photos you optionally upload.</li>
  </ul>

  <h3>How We Use Your Data</h3>
  <ul>
    <li>To provide and operate core app features (saving and tracking matches).</li>
    <li>To generate statistics, charts and reports about your performance.</li>
    <li>To personalize the app and improve your experience.</li>
    <li>To manage accounts, authentication, and customer support.</li>
  </ul>

  <h3>Data Sharing</h3>
  <p>
    We do not sell your personal data. Data is stored securely with third-party providers (for example Firebase by Google) to enable the app’s functionality. We only share data with third parties when you explicitly consent (for example exporting or sharing results), or when required by law.
  </p>

  <h3>User Control</h3>
  <p>
    You can access, correct or delete your personal data. You may request account deletion and removal of associated data through the app's "Delete Account" option or by contacting us.
  </p>

  <h3>Security</h3>
  <p>
    We implement reasonable technical and organizational measures to protect your data against unauthorized access, alteration, disclosure, or destruction. However, no system is completely secure — please follow good security practices (strong password, keep device secure).
  </p>

  <h3>Changes to this Policy</h3>
  <p>
    We may update this Privacy Policy periodically. We will notify users within the app or by email about material changes.
  </p>

  <h3>Contact</h3>
  <p>
    If you have questions about this Privacy Policy or wish to exercise your rights, contact us at:
    <br />
    <a href="mailto:zielapp.contact@gmail.com">appziel2025@gmail.com</a>
  </p>
</section>

    <!-- Footer -->
    <footer class="footer">
      <router-link to="/">Back to Home</router-link>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'PrivacyPolicy'
}
</script>

<style scoped>
.privacy {
  min-height: 100vh;
  background: linear-gradient(45deg, #35080a, #151b28);
  color: white;
  font-family: "Arial", sans-serif;
  padding: 2rem 10%;
}

.header {
  text-align: center;
  margin-bottom: 2rem;
}

.logo {
  width: 100px;
  height: 100px;
}

.title {
  font-size: 3rem;
  margin: 1rem 0 0 0;
}

.subtitle {
  font-size: 2rem;
  opacity: 0.9;
}

.content h3 {
  margin-top: 2rem;
  font-size: 1.8rem;
}

.content p ,

.content li {
  font-size: 1.2rem;
  line-height: 1.6;
  text-align: left;
}

.content ul {
  margin-left: 1.5rem;
}

.footer {
  text-align: center;
  margin-top: 3rem;
}

.footer a {
  color: white;
  text-decoration: underline;
}
</style>
